import API from "@/lib/API";

export const getTowerCustomers = async (params = {}) => {
  return await API.get("Verve/customers", { params });
};
